import React from "react";
import { Modal, Segment } from "semantic-ui-react";
import "./Form.scss";

type IRemoveViewModalProps = {
  open: boolean;
  close: () => void;
  onSubmit: () => void;
};

export const RemoveViewModal = (props: IRemoveViewModalProps) => {
  const { open, close, onSubmit } = props;

  return (
    <Modal
      open={open}
      header='Delete View?'
      closeIcon={true}
      onClose={() => close()}
      size='small'
      content={
        <Segment basic className='delete_view_modal'>
          <p>Are you sure you want to delete this view? This action cannot be undone.</p>
        </Segment>
      }
      actions={[
        { content: "Cancel", key: "cancel", basic: true, onClick: () => close() },
        { content: "Delete", key: "delete", color: "red", onClick: onSubmit },
      ]}
    />
  );
};
